import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {OrganizationService} from '@middleware';
import {SetOrganizations} from '@validators/org-email.validator';
import {lastValueFrom} from 'rxjs';

/**
 * Resolver to fetch organizations and current user to populate validator state.
 * This ensures that org-email and includes-self validators have data before the form renders.
 */
export const validationDataResolver: ResolveFn<boolean> = async () => {
  const orgService = inject(OrganizationService);

  try {
    const orgs = await lastValueFrom(orgService.getOrganizations());

    if (orgs?.organizations) {
      SetOrganizations(orgs.organizations);
    }

    return true;
  } catch (error) {
    console.error('Error in validationDataResolver:', error);
    // We return true anyway to let the component load; the validator handles null state gracefully.
    return false;
  }
};
